import "./ContactsPage.scss";
import Header from "../../components/Header/Header";

export const ContactsPage = () => {
  return (
    <>
      <Header variant="public" />
      <main className="legal-page">
        <section className="legal-page__hero">
          <p className="legal-page__eyebrow">Контакты</p>
          <h1 className="legal-page__title">Контакты и реквизиты</h1>
        </section>

        <section className="legal-page__content">
          <h2>01. Реквизиты</h2>
          <p><strong>Исполнитель:</strong> Самозанятый Саркисян Арман Артурович · <strong>ИНН:</strong> 616511934195 · <strong>Статус:</strong> Самозанятый (НПД) · <strong>Сайт:</strong> <a href="https://code-career.ru">https://code-career.ru</a> · <strong>Сервис:</strong> «Neuro Boost» — AI-помощник для подготовки к техническим собеседованиям</p>

          <h2>02. Контакты для обращений</h2>
          <div className="legal-page__block">
            <p><strong>Служба поддержки:</strong></p>
            <p>Email: <a href="mailto:code.career.ru@mail.ru">code.career.ru@mail.ru</a></p>
          </div>

          <p><strong>Направления обращений:</strong></p>
          <ul>
            <li>Вопросы по оплате и подписке — <a href="mailto:code.career.ru@mail.ru">code.career.ru@mail.ru</a> (тема «Подписка»)</li>
            <li>Возврат средств — <a href="mailto:code.career.ru@mail.ru">code.career.ru@mail.ru</a> (тема «Возврат»), порядок — в <a href="/refund">Правилах возврата</a></li>
            <li>Претензии и юридические вопросы — <a href="mailto:code.career.ru@mail.ru">code.career.ru@mail.ru</a> (тема «Претензия»), срок ответа — до 10 рабочих дней</li>
            <li>Правообладателям — <a href="mailto:code.career.ru@mail.ru">code.career.ru@mail.ru</a> (тема «Правообладателям»)</li>
          </ul>

          <p><strong>Оплата:</strong> ЮKassa (карты РФ, СБП)</p>
          <p><strong>Режим работы поддержки:</strong> пн–пт, 10:00–19:00 (МСК). Ответы на обращения, поступившие вне рабочего времени, — на следующий рабочий день. Гарантии времени ответа (SLA) не предоставляются.</p>

          <h2>03. Документы</h2>
          <p>• <a href="/offer">Пользовательское соглашение</a> — договор на оказание услуг.<br />• <a href="/privacy">Политика конфиденциальности</a> — порядок обработки персональных данных.<br />• <a href="/consent">Согласие на обработку персональных данных</a> — согласие субъекта на обработку.<br />• <a href="/cross-border-consent">Согласие на трансграничную передачу</a> — согласие на передачу данных за пределы РФ.<br />• <a href="/refund">Правила возврата</a> — порядок отказа от покупки.<br />• <a href="/rights-holders">Информация для правообладателей</a>.</p>
        </section>
      </main>
    </>
  );
};